/**
 * @param  {Object[]} sources
 * @return {Object|null}
 */
import virtualScreenWidth from './virtualScreenWidth';

export default (sources) => {
  if (!sources || !sources.length) {
    return null;
  }

  return sources
    .map((source) => {
      const [url, spec] = source.split(' ');
      const [resolution, videoType] = spec.split(':');

      const score = Math.abs(resolution - virtualScreenWidth());

      return {
        url,
        resolution,
        videoType,
        score,
      };
    })
    .sort((sourceA, sourceB) => {
      if (sourceA.score === sourceB.score) {
        return 0;
      }

      return sourceA.score < sourceB.score ? -1 : 1;
    })[0];
};
